<template>
  <el-container class="login_box" style="flex-flow: column">
    <div class="notice">
      <span class="notice_text">新版系统</span><a href='https://mp.weixin.qq.com/s/7FALVppzRFy8ZFeYoDJpJw' target="_blank">已经上线啦！</a>
      <span class="notice_text">请移步</span> <a href='https://vscope-v3.csm.com.cn' target="_blank">V+Scope v3</a>
    </div>
    <div class="login-container">
      <div class="login-body">
        <div class="login_img_box">
          <img src="../../assets/images/login_logo.png" alt="" style="width: 450px;" />
        </div>
        <div style="font-size: 55px;margin: 30px 0px;letter-spacing:20px;">
          <span class="login_title">融合媒体数据云平台</span>
        </div>
        <el-form v-if="isPhone === '账号密码登录'" id="nowlogn" :model="formData" :rules="rules" ref="ruleForm" autocomplete="off" label-width="180px">
          <div class="login_btn">
            <img src="../../assets/images/login_btn.png" @click="loginPhone" alt="" class="sbumitbtn" />
          </div>
          <el-form-item prop="mobile" label="手机号" class="register-form-item" style="margin-bottom: 20px;color: #fff;">
            <div class="phone_box">
              <img src="../../assets/images/input_down.png" class="ipttwo" alt="" style="width: 370px;" />
              <el-input v-model="formData.mobile" size="medium" placeholder="请输入您的手机号">
              </el-input>
            </div>
          </el-form-item>
          <el-form-item prop="code" label="验证码" class="register-form-item">
            <img src="../../assets/images/input_up.png" class="ipttwo" alt="" style="width: 370px;" />
            <img src="../../assets/images/code.png" class="iptcode" alt="" />
            <el-input v-model="formData.code" size="medium" placeholder="请输入验证码" @keyup.enter.native="loginPhone()">
              <el-button v-if="!timer" type="primary" slot="append" @click="getCode">获取验证码</el-button>
              <span v-else slot="append">{{ seconds }} 秒</span>
            </el-input>
          </el-form-item>
          <el-form-item class="register-form-item">
            <el-button type="text" class="change" style="float:left" @click="loginMethod">{{ isPhone }}</el-button>
            <!-- <el-button type="text" style="float:right" @click="$router.push('/register')">注册账户</el-button> -->
          </el-form-item>
        </el-form>

        <el-form v-else id="nowlogn" :model="formData" :rules="rules" ref="ruleForm" label-width="180px">
          <div class="login_btn">
            <img src="../../assets/images/login_btn.png" @click="login" alt="" class="sbumitbtn" />
          </div>
          <el-form-item prop="username" label="用户名" class="register-form-item" style="margin-bottom: 20px;color: #fff;">
            <div class="phone_box">
              <img src="../../assets/images/input_down.png" class="ipttwo" alt="" style="width: 370px;" />
              <el-input v-model="formData.username" size="medium" placeholder="请输入您的用户名" @keyup.enter.native="login()">
              </el-input>
            </div>
          </el-form-item>
          <el-form-item prop="password" label="密　码" class="register-form-item">
            <img src="../../assets/images/input_up.png" class="ipttwo" alt="" style="width: 370px;" />
            <el-input v-model="formData.password" size="medium" placeholder="请输入您的密码" type="password" @keyup.enter.native="login()">
            </el-input>
          </el-form-item>
          <el-form-item prop="captcha" label="验证码" class="register-form-item" style="margin-bottom: 0;">
            <el-input v-model="formData.captcha" placeholder="验证码" style="width: 55%;margin-right: 3%;height: 48px;
    line-height: 48px;" @keyup.enter.native="login()"></el-input>
            <div class="clickcode">
              <img class="clickcodeImg" :src="captcha.image_base" @click="loadCaptcha" />
            </div>
          </el-form-item>

          <!-- <el-form-item class="register-form-item" style="margin-bottom: 0;">
            <el-checkbox
              v-model="rememberMe"
              style="color:#fff; float:left;display:height: 40px;line-height:40px;"
            >
              自动登录
            </el-checkbox>
            <el-button
              type="text"
              style="float:right;display:inline-block"
               class="change"
              @click="$router.push('/password/reset')"
            >
              忘记密码
            </el-button>
          </el-form-item> -->
          <el-form-item class="register-form-item">
            <el-button type="text" class="changePassword" style="float:left;display:inline-block" @click="loginMethod">{{ isPhone }}</el-button>
            <el-button type="text" style="float:right;display:inline-block" class="changePassword" @click="$router.push('/password/reset')">
              忘记密码
            </el-button>
            <!-- <el-button type="text" style="float:right" @click="$router.push('/register')">注册账户</el-button> -->
          </el-form-item>
        </el-form>
      </div>
    </div>

    <el-footer class="footer">
      <div>
        <span>中国广视索福瑞媒介研究 Copyright© {{ new Date().getFullYear() }}</span>
      </div>
      <div style="margin-left: 20px;">
        <!-- <a href="" class="tooltip">用户手册</a> -->
        <!-- <a href="" class="tooltip">常见问题</a> -->
        <el-button @click="aboutUs" type="text" class=" tooltip">联系我们</el-button>
        <el-button @click="feedbackDialog" type="text" class="">在线反馈</el-button>
      </div>
    </el-footer>
    <!-- 意见反馈 -->
    <Dialog-form v-if="dialogForm"></Dialog-form>
  </el-container>
</template>

<script>
let that
var numname = 0
import DialogForm from '@/components/common/DialogForm.vue'

export default {
  components: {
    DialogForm
  },
  name: 'app',
  data() {
    var checkMobile = (rule, value, callback) => {
      if (!value) {
        return callback(new Error('请输入手机号'))
      } else {
        var reg = /^1\d{10}$/
        if (reg.test(value)) {
          callback()
        } else {
          return callback(new Error('手机号格式有误，请重新输入'))
        }
      }
    }
    var checkUserName = (rule, value, callback) => {
      if (!value) {
        return callback(new Error('请输入用户名'))
      } else {
        if (value.length < 3 || value.length > 20) {
          return callback(new Error('用户名长度应为3-20个字符'))
        } else {
          callback()
        }
      }
    };
    return {
      dialogForm: false,
      timer: null,
      isPhone: '账号密码登录',
      captcha: {
        image_base: ''
      },
      formData: {
        mobile: '',
        code: '',
        username: '',
        captcha: '',
        password: ''
      },
      rememberMe: false,
      rules: {
        mobile: [{ validator: checkMobile, trigger: ['blur', 'change'] }],
        username: [
          { validator: checkUserName, trigger: ['blur', 'change'] },
        ],
        password: [
          {
            message: '请输入密码',
            trigger: ['blur', 'change']
          },
          {
            min: 4,
            max: 16,
            message: '密码长度应为4-16个字符',
            trigger: ['blur', 'change']
          }
        ],
        captcha: [{ message: '请输入验证码', trigger: 'blur' }]
      }
    }
  },
  mounted() {
    that = this
    this.loadCaptcha()
    let userAgent = navigator.userAgent //取得浏览器的userAgent字符串
    let isOpera = userAgent.indexOf('Opera') > -1
    this.checkBrowser(isOpera, userAgent)
    // console.log( this.checkBrowser(isOpera,userAgent))
    if (this.checkBrowser(isOpera, userAgent) === 'IE') {
      this.$confirm(
        ' 为了更好的使用体验，请您使用 谷歌浏览器 Chrome、火狐浏览器 Firefox、Safari 浏览器或微软 Edge 浏览器 访问本站。',
        '温馨提示',
        {
          confirmButtonText: '点击下载谷歌浏览器',
          cancelButtonText: '关闭'
          // type: 'warning'
        }
      ).then(() => {
        window.open(
          'https://dl.google.com/tag/s/appguid%3D%7B8A69D345-D564-463C-AFF1-A69D9E530F96%7D%26iid%3D%7B9F4B089D-7D5A-E040-51B9-3679149DDAE0%7D%26lang%3Dzh-CN%26browser%3D4%26usagestats%3D0%26appname%3DGoogle%2520Chrome%26needsadmin%3Dprefers%26ap%3Dx64-stable-statsdef_1%26installdataindex%3Dempty/chrome/install/ChromeStandaloneSetup64.exe'
        )
      })
    }
  },

  methods: {
    checkBrowser(isOpera, userAgent) {
      if (isOpera) {
        return 'Opera'
      } //判断是否Opera浏览器
      if (userAgent.indexOf('Firefox') > -1) {
        return 'FF'
      } //判断是否Firefox浏览器
      if (userAgent.indexOf('Chrome') > -1) {
        return 'Chrome'
      }
      if (userAgent.indexOf('Safari') > -1) {
        return 'Safari'
      } //判断是否Safari浏览器
      //判断是否IE<11浏览器
      if (
        userAgent.indexOf('compatible') > -1 &&
        userAgent.indexOf('MSIE') > -1 &&
        !isOpera
      ) {
        return 'IE'
      } //判断是否IE11浏览器
      if (
        userAgent.indexOf('Trident') > -1 &&
        userAgent.indexOf('rv:11.0') > -1
      ) {
        return 'IE'
      }
    },
    //获取联系我们电话
    aboutUs() {
      this.$alert(
        `       <strong>联系人：耿頔</strong> <br>
                <strong>电话：010-85086652</strong> <br>
                <strong>手机号：13521532019</strong> <br>
                <strong>邮箱：gengdi@csm.com.cn</strong>
        `,
        '联系我们',
        {
          dangerouslyUseHTMLString: true
        }
      )
    },
    feedbackDialog() {
      if (this.userInfo) {
        this.dialogForm = true
      } else {
        this.$confirm('请先登录', '提示', {
          confirmButtonText: '知道了',
          showCancelButton: false,
          type: 'warning',
          center: true
        }).then(() => { })
      }
    },

    loginMethod() {
      if (this.isPhone === '手机号登陆') {
        this.isPhone = '账号密码登录'
      } else {
        this.isPhone = '手机号登陆'
        this.$refs['ruleForm'].resetFields()
      }
    },
    // 手机号登陆
    loginPhone() {
      this.$refs.ruleForm.validate(valid => {
        if (valid) {
          // this.formData.ima_id = this.captcha.id + ''
          this.api.account.phone_no_login(this.formData).then(
            res => {
              if (res.data.return_code === 0) {
                sessionStorage.setItem('token', res.data.detail.token)
                this.api.account.getUserInfo().then(res => {
                  let userInfo = res.data.detail
                  this.$store.commit('setAvatar', userInfo.avatar)
                  let role = userInfo.role_member.role
                  let userrole = {}
                  if (role) {
                    userrole = { ...this.authData.all[role] }
                  }
                  if (
                    userInfo.custom_role_member.role &&
                    userInfo.custom_role_member.role == 'custom_member'
                  ) {
                    let custom_member = {
                      ...this.authData.all[userInfo.custom_role_member.role]
                    }
                    Object.keys(custom_member).forEach(function (key) {
                      userrole[key] = custom_member[key]
                    })
                  }
                  if (
                    userInfo.role_member.role &&
                    userInfo.role_member.role == 'business_administrator'
                  ) {
                    sessionStorage.setItem('adminUser', 1)
                  }
                  this.setAuthData(userrole)
                  this.authData.user = userrole
                  sessionStorage.setItem(
                    'authData',
                    JSON.stringify(this.authData.user)
                  )
                  sessionStorage.setItem('userInfo', JSON.stringify(userInfo))
                  that.$router.push('/home')
                  //记录首页hash值 或者不用hash路由 可删除
                  // let stack_key =
                  //   that.$router.history.current.query['stack-key']
                  // sessionStorage.setItem('stack-key', stack_key)
                  // sessionStorage.setItem('reloadFlag',-1);  //设置浏览器默认刷新状态
                })
              }
            },
            error => {
              //              if (error.response.data.detail && error.response.data.detail.captcha[0]) {
              //                this.$message.error(error.response.data.detail.captcha[0])
              //              } else {
              //                this.$message.error('您输入的密码不正确，请重新输入。')
              //              }
            }
          )
        } else {
          return false
        }
      })
    },
    // 账号密码登录
    login() {
      this.$refs.ruleForm.validate(valid => {
        if (valid && this.formData.password !== '' && this.formData.captcha !== '') {
          this.formData.ima_id = this.captcha.id + ''
          this.api.account
            .login(this.formData)
            .then(
              res => {
                if (res.data.return_code === 0) {
                  sessionStorage.setItem('token', res.data.detail.token)
                  this.api.account.getUserInfo().then(res => {
                    let userInfo = res.data.detail
                    this.$store.commit('setAvatar', userInfo.avatar)
                    let role = userInfo.role_member.role
                    let userrole = {}
                    if (role) {
                      userrole = { ...this.authData.all[role] }
                    }
                    // console.log(this.authData.all)
                    if (
                      userInfo.custom_role_member.role &&
                      userInfo.custom_role_member.role == 'custom_member'
                    ) {
                      let custom_member = {
                        ...this.authData.all[userInfo.custom_role_member.role]
                      }
                      Object.keys(custom_member).forEach(function (key) {
                        userrole[key] = custom_member[key]
                      })
                    }
                    if (
                      userInfo.role_member.role &&
                      userInfo.role_member.role == 'business_administrator'
                    ) {
                      sessionStorage.setItem('adminUser', 1)
                    }
                    // console.log(userrole)
                    this.setAuthData(userrole)
                    this.authData.user = userrole
                    sessionStorage.setItem(
                      'authData',
                      JSON.stringify(this.authData.user)
                    )
                    sessionStorage.setItem('userInfo', JSON.stringify(userInfo))
                    that.$router.push('/home')
                    // let stack_key =
                    //   that.$router.history.current.query['stack-key']
                    // sessionStorage.setItem('stack-key', stack_key)
                    // sessionStorage.setItem('reloadFlag',-1);  //设置浏览器默认刷新状态
                  })
                }
              },
              error => { }
            )
            .catch(error => {
              // console.log(error.response.data);
            })
        } else {
          this.$message.error('请填写完整信息')
          return false
        }
      })
    },
    loadCaptcha() {
      this.api.account.getCaptcha().then(res => {
        if (res) {
          that.captcha.id = res.data.id
          that.captcha.image_base =
            'data:image/png;base64,' + res.data.image_base
          numname = 0
        } else {
          numname++
          if (numname < 9) {
            setTimeout(() => {
              this.loadCaptcha()
            }, 2000)
          }
        }
      })
    },

    // 获取手机短信验证码
    getCode() {
      let mobile = this.formData.mobile
      if (!mobile) {
        this.$alert('请输入手机号', '提示', { type: 'warning' })
        //  this.$message({type: 'warning',message: '请输入手机号!'})
      } else {
        var reg = /^1[345789]\d{9}$/
        if (reg.test(mobile)) {
          that.api.account.loginsms_code(this.formData).then(res => {
            if (res.data.message == 'Successful') {
              that.$message.success('验证码发送成功')
            } else {
              that.$message.error(res.data.message)
            }
          })
        } else {
          this.$alert('手机号格式有误，请重新输入', '提示', { type: 'warning' })
        }
      }
    }
  }
}
</script>

<style scoped lang="less">
.login_box {
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center;
  background-image: url('../../assets/images/login.png');
  .notice {
    width: 100%;
    height: 35px;
    line-height: 35px;
    background: #acb9c5;
    color: #fff;
    font-size: 20px;
    text-align: center;
    font-family: 'bigruixianlightgb4';
    font-weight: bold;
    .notice_text {
      color: #2e3857;
    }
    a {
      color: #e10073;
      text-decoration: none;
    }
  }
}

#nowlogn /deep/ .el-input--mini .el-input__inner {
  height: 48px;
  line-height: 48px;
  color: #fff;
  background: #20272b69;
  border: 1px solid #100f0f1f;
  border-radius: 9px;
  font-size: 14px;
  letter-spacing: 1px;
}

.clickcode {
  vertical-align: bottom;
  width: 42%;
  height: 46px;
  line-height: 36px;
  margin-bottom: 1px;
  background: #fff;
  display: inline-block;
  border-radius: 9px;
  overflow: hidden;
  cursor: pointer;
}

.clickcodeImg {
  width: 100%;
  vertical-align: bottom;
}

#nowlogn .el-form-item__label {
  width: 180px;
  height: 48px;
  line-height: 48px;
}

.ipttwo {
  width: 370px;
  position: absolute;
}

.iptcode {
  width: 152px;
  position: absolute;
  right: 0;
}
.login_btn {
  height: 66px;
  line-height: 65px;
  position: absolute;
  top: 24px;
  right: -38px;
  border: 1px solid #00000026;
  border-radius: 50%;
  cursor: pointer;
  z-index: 99999;
}
.sbumitbtn {
  width: 66px;
}

.change {
  color: #01e5ff;
  margin-left: 16px;
  margin-top: -12px;
  font-size: 16px;
  font-family: 'bigruixianlightgb4';
  font-weight: bold;
  letter-spacing: 1px;
}

.changePassword {
  color: #01e5ff;
  margin-left: 16px;
  margin-top: 5px;
  font-size: 16px;
  font-family: 'bigruixianlightgb4';
  font-weight: bold;
  letter-spacing: 1px;
}

#nowlogn {
  width: 550px;
  height: 220px;
  text-align: right;
  margin-left: 16%;
  position: relative;
}

#nowlogn /deep/ .el-input-group__append {
  width: 111px;
  text-align: left;
  color: #01e5ff;
  background-color: #ffffff00 !important;
  border: none;
}

#nowlogn /deep/ .el-form-item__label {
  color: #fff !important;
  font-size: 18px;
  height: 48px;
  line-height: 48px;
  font-family: 'bigruixianlightgb4';
  font-weight: bold;
  letter-spacing: 1px;
}
#nowlogn /deep/ .el-input--medium .el-input__inner {
  background-color: #ffffff00 !important;
  border: none !important;
  height: 48px;
  line-height: 48px;
  color: #fff;
  letter-spacing: 1px;
}

#nowlogn /deep/ .el-form-item--mini .el-form-item__error {
  padding-top: 4px;
}
#nowlogn /deep/ .el-form-item__error {
  color: #f56c6c;
  font-size: 12px;
  line-height: 1;
  padding-top: 4px;
  position: absolute;
  top: 100%;
  left: 15px;
}
.phone_box {
  // background-image: url('../../assets/images/input_up.png');
  // background-repeat: no-repeat;
}
// .round{
//     width: 65px;
//     height: 65px;
//     border-radius: 50%;
//     background: red;
//     position: absolute;
//     right: -30px;
//     top: -52px;
// }
.login_title {
  font-family: 'bigruixianlightgb4';
}
.login_img_box {
  padding-right: 20px;
}
.logo {
  background-image: url('../../assets/images/logo.png');
  height: 120px;
  width: 450px;
  background-repeat: no-repeat;
}
#nowlogn .el-form-item--mini .el-form-item__error {
  padding-top: 3px;
}
#nowlogn .el-form-item__error {
  color: #f56c6c;
  font-size: 10px;
  line-height: 1;
  padding-top: 4px;
  position: absolute;
  top: 100%;
  left: 17px;
}
.login-container {
  height: 100%;
  display: flex;
  color: #fff;
  align-items: center;
  justify-content: flex-end;
  /* margin-right: 260px; */
  margin-right: 15%;
}

.login-body {
  text-align: right;
  /* width: 100%;
    display: flex;   
    justify-content: center; */
}

.login-form-item {
  margin-top: 20px;
}

.login-qq {
  width: 32px;
  height: 32px;
  display: inline-block;
  margin-top: 7px;
  margin-left: 20px;
  background-color: #fff;
  border-radius: 16px;
  background-image: url('../../assets/images/qq.png');
}

.login-wb {
  width: 32px;
  height: 32px;
  display: inline-block;
  margin-top: 7px;
  margin-left: 20px;
  background-image: url('../../assets/images/wb.png');
}

.login-wx {
  width: 32px;
  height: 32px;
  display: inline-block;
  margin-top: 7px;
  margin-left: 20px;
  background-image: url('../../assets/images/wx.png');
}
</style>
